import { render, staticRenderFns } from "./CreateFormulaCard.vue?vue&type=template&id=2eb52fbb&scoped=true&"
import script from "./CreateFormulaCard.vue?vue&type=script&lang=js&"
export * from "./CreateFormulaCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateFormulaCard.vue?vue&type=style&index=0&id=2eb52fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb52fbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCheckbox,VDatePicker,VIcon,VMenu,VSelect,VSimpleTable,VTextField,VTextarea})
